import { Dispatch, FC, SetStateAction, useMemo } from "react";
import { GridApi } from "ag-grid-community";
import { useFlag } from "@unleash/proxy-client-react";
import { OffHoursSchedule } from "@/services/cloudchipr.api";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";
import { offHoursGridColumnDefs } from "@/components/pages/automations/off-hours/grid/offHoursGridColumnDefs";

interface OffHoursGridProps {
  data: OffHoursSchedule[];
  setGridApi: Dispatch<SetStateAction<GridApi | null>>;
}

export const OffHoursGrid: FC<OffHoursGridProps> = ({ data, setGridApi }) => {
  const enableOffHoursLastExecutionColumn = useFlag(
    "EnableOffHoursLastExecutionColumn",
  );

  const columnDefs = useMemo(() => {
    if (!enableOffHoursLastExecutionColumn) {
      return offHoursGridColumnDefs.filter(
        (col) => col.field !== "last_execution",
      );
    }

    return offHoursGridColumnDefs;
  }, [enableOffHoursLastExecutionColumn]);

  return (
    <AgDataGrid
      rowData={data}
      rowHeight={64}
      headerHeight={56}
      gridApiSetter={setGridApi}
      defaultColDef={defaultColDef}
      columnDefs={columnDefs}
      configToRememberStateInStorage={configToRememberStateInStorage}
    />
  );
};

const configToRememberStateInStorage = {
  uniqueNameAsKey: "off-hours-grid",
};

const defaultColDef = {
  flex: 5,
  minWidth: 180,
  sortable: true,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
};
